// extracted by mini-css-extract-plugin
export default {"wrapper":"ZMDnP","label":"Kow0V"};